/**
    * ImageLoader description
    * (c) lg2fabrique 2017
*/
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';

export default class ImageLoader extends AbstractDispatcher {
        
    public static LOADED    : string    = 'LOADED'
        

    private _arrayLength    : number;
    private _loadedIndex    : number    = 0;
    /**
    * constructor
    */
    constructor(element: NodeListOf<HTMLElement>) {
        super();
        
        // Dispatch exemple
        
        this._arrayLength = element.length;

        for (var i = 0; i < this._arrayLength; i++) {
            let el = element[i];
            let img = el.querySelector('img') as HTMLImageElement;
            img.onload = () => {
                this._loadedIndex++;
                el.setAttribute('data-image-resize', ""+img.height/img.width);
                if (this._loadedIndex == element.length) this.dispatch({type:ImageLoader.LOADED})
            }
        }
    };
}